<app-dataview [identifier]="'plans-view'" [title]="title" [showtree]="true" [sidepaneltitle]="sidepaneltitle" [treedata]="menuItems" [url]="url"></app-dataview>